module.exports = __webpack_public_path__ + "static/two-0b3c6c7ed76db6335962887be429a867.png";